import { postFmsPrintPdf } from '#/api/fmsMgmt/printPdf';

/** POST `/fms/payment-requests/{id}/print`：對登入者可見即可印，任何狀態 */
export async function printPaymentRequest(id, { requestNo } = {}) {
  return postFmsPrintPdf(`/fms/payment-requests/${id}/print`, {
    fallbackFilename: `${requestNo || 'payment-request'}.pdf`,
  });
}
